// S3 · Cómo se elige el valor asegurado según la ficha (reunión 14-oct): lista de planes cerrados,
// caja con rango abierto, o planes por banda de edad. Las cifras salen de fichas-productos.json.
import fichas from '../datos/fichas-productos.json';

const ficha = (id) => fichas.productos.find((p) => p.id === id);
const num = (s) => Number(String(s || '').replace(/\D/g, '')) || null;

function capital() {
  const f = ficha('seguro-capital-en-vida');
  const planes = f.filas.filter((r) => r.Cobertura === 'Muerte').map((r) => ({
    id: r.Plan, label: r.Plan, va: num(r['Límite / valor asegurado (COP)']), prima: num(r['Valor de la prima']),
  }));
  return { modo: 'lista', planes };
}

function cancer() {
  const f = ficha('seguro-integral-para-cancer');
  const bandas = {};
  let banda = null;
  f.filas.forEach((r) => {
    const e = r['Edad / plazo / zona / valor asegurado'];
    if (e) banda = e.replace(/Edad\s*/, '').replace(/\s*años/, '').replace('-', '–');
    if (!banda || !r['Prima mensual']) return;
    const va = num(r['Valor asegurado (COP)']);
    (bandas[banda] = bandas[banda] || []).push({ id: `$${va / 1e6} M`, label: `$${va / 1e6} millones`, va, prima: num(r['Prima mensual']) });
  });
  return { modo: 'lista_por_edad', bandas };
}

function medida() {
  const f = ficha('plan-vida-a-la-medida');
  const v = (txt) => num((f.filas.find((r) => r.Cobertura === txt) || {})['Límite / valor asegurado (COP)']);
  return {
    modo: 'caja',
    min: v('Muerte por cualquier causa (mínimo)'),
    max: v('Muerte por cualquier causa (máximo)'),
    paso: 1000000,
    rapidos: [20000000, 50000000, 100000000],
    primaDesde: num(f.filas[0]['Valor de la prima']),
  };
}

export const PLANES = { 'capital-vida': capital(), 'cancer-integral': cancer(), 'vida-medida': medida() };
export const tienePlanes = (id) => Boolean(PLANES[id]);
